import { useDesignBoardPageState } from '../../context';
import type { DesignBoardWithDetailedPinsFragment } from 'generated/graphql';
import { PencilLine } from '@archipro-design/icons';
import BoardActionWithLoginPrompt from '@modules/design-board/component/board-detail/BoardActionWithLoginPrompt';
import { useTracker } from '@archipro-website/tracker';
import { Button as RoccoButton } from '@archipro/rocco/components/button';

interface EditButtonProps {
    board: DesignBoardWithDetailedPinsFragment;
}

const EditButton = ({ board }: EditButtonProps) => {
    const { dispatch } = useDesignBoardPageState();
    const tracker = useTracker();

    const onEditBoard = () => {
        dispatch({
            type: 'OpenEditDrawer',
            designBoardInput: {
                title: board.Title,
                description: board.Content !== null ? board.Content : undefined,
                isPrivate: !board.Public,
                id: board.ID,
            },
        });
        tracker.log('EditBoardReveal', {
            url: new URL(window.location.href),
            data: {
                ElementID: 'designboard_detail_header_editBoardReveal',
                Source: 'designBoard, detail, header',
            },
        });
    };

    return (
        <BoardActionWithLoginPrompt
            action={
                <RoccoButton
                    color="outline"
                    onClick={onEditBoard}
                    shape="square"
                    weight="normal"
                    className="hover:bg-black hover:text-white hover:fill-white [&_svg]:hover:text-white"
                >
                    <PencilLine className="w-4 h-4 mr-2" />
                    EDIT
                </RoccoButton>
            }
        />
    );
};

export default EditButton;
